import { Tooltip } from '@mui/material';
import { StyledPrimaryActionButton, StyledCancelButton } from './styled/buttons';
import { useTranslation } from 'react-i18next';

const ActionButtons = ({
	entry,
	isEditing,
	editPrice,
	onSaveEdit,
	onCancelEdit,
	onOpenDeleteDialog,
	onEditTravelPolicy,
}) => {
	const { t } = useTranslation();

	return (
		<div className="entry-row-wrapper flex align-center flex-end">
			{isEditing ? (
				<>
					<StyledCancelButton className="action-button cancel" onClick={onCancelEdit}>
						{t('TravelPolicy.Actions.Cancel')}
					</StyledCancelButton>
					<StyledPrimaryActionButton
						className="action-button"
						onClick={() => onSaveEdit(entry._id)}
						disabled={!(editPrice > 0)}
					>
						{t('TravelPolicy.Actions.Save')}
					</StyledPrimaryActionButton>
				</>
			) : (
				<>
					<Tooltip title={t('TravelPolicy.Actions.Remove.Policy')} arrow placement="top">
						<button className="action-icon remove-button" onClick={() => onOpenDeleteDialog(entry._id)} />
					</Tooltip>
					<Tooltip title={t('TravelPolicy.Actions.Edit.Policy')} arrow placement="top">
						<button className="action-icon edit-button" onClick={() => onEditTravelPolicy(entry)} />
					</Tooltip>
				</>
			)}
		</div>
	);
};

export default ActionButtons;
